// extracted by mini-css-extract-plugin
export default {"icon":"screeningStatus_icon__lPx6O","label":"screeningStatus_label__wS8Jz","optioncontainer":"screeningStatus_optioncontainer__kaS8v"};